class ProductPicker {
  constructor() {
    this.offersGroups = document.querySelectorAll('.picker-dogsize_offers-group');
    this.offersItems = document.querySelectorAll('.picker-offer_input');
    this.dogSizeInputs = document.querySelectorAll('.picker-dogsize_input');
    // Support both data attributes (new) and IDs (legacy) for backward compatibility
    this.purchaseTypeInput = this.getElement('[data-purchase-type-toggle]', 'js__picker-purchase_type');
    this.dogSizesTrigger = this.getElement('[data-dogsizes-trigger]', 'dogsizes-selector-trigger');
    this.dogsizesTarget = this.getElement('[data-dogsizes-target]', 'dogsizes-selector-target');
    this.productForm = this.getElement('[data-picker-form]', 'product-picker-form');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.skipCart = this.productForm?.dataset.skipCart !== undefined;
    this.subscriptionNotice = document.querySelector('subscription-notice');
    this.subscriptionNotice && this.subscriptionNotice.init(this);

    // Quantity selector
    this.qtySelector = document.querySelector('[data-picker-qty-selector]');
    this.qtyInput = document.querySelector('[data-picker-qty-input]');
    this.qtyMultiplier = 1;

    // Discount code from CTA button
    this.discountCode =
      this.getElement('[data-submit-button]', 'picker-submit_button-sub')?.dataset.discountCode || null;

    this.init();
  }

  // Helper to find element by data attribute first, then fallback to ID
  getElement(dataSelector, legacyId) {
    return document.querySelector(dataSelector) || document.getElementById(legacyId);
  }

  setButtonsLoading(loading) {
    const buttons = [
      this.getElement('[data-submit-button]', 'picker-submit_button-sub'),
      this.getElement('[data-otp-button]', 'picker-submit_button-otp'),
      this.getElement('[data-otp-checkout-button]', 'picker-submit_button-otp-checkout'),
      this.getElement('[data-checkout-button]', 'picker-checkout_button'),
    ];
    buttons.forEach((btn) => {
      if (!btn) return;
      btn.disabled = loading;
      btn.style.opacity = loading ? '0.6' : '';
      btn.style.pointerEvents = loading ? 'none' : '';
    });
  }

  init() {
    this.dogSizeInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.updateOfferGroups();
        if (window.innerWidth < 950) {
          this.updateDogsizeSelector(input);
        }
      });
    });

    this.offersItems.forEach((offer) => {
      offer.addEventListener('change', () => this.updateCTA());
      offer.addEventListener('change', this.croUpdateCTA.bind(this));
      offer.addEventListener('change', () => this.updateCheckoutButton());
    });

    if (this.purchaseTypeInput) {
      this.purchaseTypeInput.addEventListener('change', () => {
        this.updateOfferGroups();
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      this.updateOfferGroups();
    });

    // Note: dogsize trigger click handling is now managed by _pdp-picker-dogsizes block

    const addToCartButton = this.getElement('[data-submit-button]', 'picker-submit_button-sub');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setButtonsLoading(true);
        this.subscriptionNotice ? this.subscriptionNotice.open() : this.prepareAddToCart();
      });
    }

    const otpButton = this.getElement('[data-otp-button]', 'picker-submit_button-otp');
    if (otpButton) {
      otpButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setButtonsLoading(true);
        this.addToCartOTP();
      });
    }

    const otpCheckoutButton = this.getElement('[data-otp-checkout-button]', 'picker-submit_button-otp-checkout');
    if (otpCheckoutButton) {
      otpCheckoutButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setButtonsLoading(true);
        this.addToCartOTPDirectCheckout();
      });
    }

    const checkoutButton = this.getElement('[data-checkout-button]', 'picker-checkout_button');
    if (checkoutButton) {
      checkoutButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setButtonsLoading(true);
        this.prepareDirectCheckout();
      });
    }

    this.offersGroups.forEach((group) => {
      group.addEventListener('change', (event) => {
        if (event.target.tagName === 'INPUT' && event.target.type === 'radio') {
          const selectedIndex = [...group.querySelectorAll('input[type="radio"]')].indexOf(event.target);
          this.syncOfferInputs(selectedIndex, group);
        }
      });
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        this.refreshCartState();
      }
    });

    // Qty selector controls
    this.initQtySelector();
  }

  initQtySelector() {
    if (!this.qtySelector || !this.qtyInput) return;

    const decreaseBtn = this.qtySelector.querySelector('[data-picker-qty-decrease]');
    const increaseBtn = this.qtySelector.querySelector('[data-picker-qty-increase]');
    const min = parseInt(this.qtyInput.min) || 1;
    const max = parseInt(this.qtyInput.max) || 100;

    const updateQty = (newValue) => {
      const value = Math.max(min, Math.min(max, newValue));
      this.qtyInput.value = value;
      this.qtyMultiplier = value;
      this.updateCTA();
      this.updateCheckoutButton();
      this.croUpdateCTA();
    };

    decreaseBtn?.addEventListener('click', () => {
      updateQty(parseInt(this.qtyInput.value) - 1);
    });

    increaseBtn?.addEventListener('click', () => {
      updateQty(parseInt(this.qtyInput.value) + 1);
    });

    this.qtyInput.addEventListener('change', () => {
      updateQty(parseInt(this.qtyInput.value) || min);
    });

    // Initialize multiplier from default value
    this.qtyMultiplier = parseInt(this.qtyInput.value) || 1;
  }

  updateCartWithoutOpening(parsedState) {
    if (!this.cart || !parsedState.sections) {
      console.warn('updateCartWithoutOpening: Missing cart or sections', {
        cart: !!this.cart,
        sections: !!parsedState.sections,
      });
      return;
    }

    const drawerInner = this.cart.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    if (this.cart.getSectionsToRender && this.cart.getSectionInnerHTML) {
      this.cart.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (sectionElement && parsedState.sections[section.id]) {
          try {
            // Null when the selector misses — cart-icon-bubble returns a bare fragment with
            // no .shopify-section wrapper. Assigning it would render the string "null".
            const updatedHTML = this.cart.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            if (updatedHTML !== null) sectionElement.innerHTML = updatedHTML;
          } catch (e) {
            console.error('Error updating section:', section.id, e);
          }
        }
      });
    }
  }

  refreshCartState() {
    if (this.cart && this.cart.tagName === 'CART-DRAWER') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          const cartIconBubble = html.querySelector('#cart-icon-bubble');
          if (cartIconBubble) {
            const targetCartIcon = document.querySelector('#cart-icon-bubble');
            if (targetCartIcon) {
              targetCartIcon.replaceWith(cartIconBubble);
              if (this.cart.setHeaderCartIconAccessibility) {
                this.cart.setHeaderCartIconAccessibility();
              }
            }
          }
        })
        .catch((e) => {
          console.error('Error refreshing cart state:', e);
        });
    }
  }

  updatePriceDisplay(priceElement, oldPriceElement, discountedPrice, defaultPrice) {
    if (!priceElement) return;

    priceElement.textContent = discountedPrice;
    if (oldPriceElement) {
      if (discountedPrice !== defaultPrice) {
        oldPriceElement.textContent = defaultPrice;
        oldPriceElement.style.display = 'inline-block';
      } else {
        oldPriceElement.style.display = 'none';
      }
    }
  }

  // Rewrites the amount inside a price string (e.g., "$29.99" -> "$59.98"), keeping its formatting.
  scalePrice(priceStr, factor) {
    if (!priceStr || factor === 1) return priceStr;
    const match = priceStr.match(/[\d,.]+/);
    if (!match) return priceStr;
    const scaled = (parseFloat(match[0].replace(/,/g, '')) * factor).toFixed(2);
    return priceStr.replace(/[\d,.]+/, scaled);
  }

  multiplyPrice(priceStr, multiplier) {
    if (multiplier <= 1) return priceStr;
    return this.scalePrice(priceStr, multiplier);
  }

  /**
   * The CTA block's extra discount as a multiplier (0.7 for 30% off), or 1 when it is off.
   *
   * Cosmetic only: it lowers the price printed on the button, never what the cart
   * charges. The actual reduction comes from the block's discount code, so the
   * merchant is responsible for keeping the percentage and the code in step.
   */
  extraDiscountFactor(button) {
    const percent = parseFloat(button?.dataset.extraDiscountPercent);
    if (!Number.isFinite(percent) || percent <= 0 || percent >= 100) return 1;
    return 1 - percent / 100;
  }

  updateCTA() {
    const activeOffer = this.getActiveOffer();
    if (!activeOffer) return;

    const baseDiscountedPrice = activeOffer.getAttribute('data-discounted-price');
    const baseDefaultPrice = activeOffer.dataset.defaultPrice;

    const button = this.getElement('[data-submit-button]', 'picker-submit_button-sub');
    const discountedPrice = this.scalePrice(
      this.multiplyPrice(baseDiscountedPrice, this.qtyMultiplier),
      this.extraDiscountFactor(button)
    );
    const defaultPrice = this.multiplyPrice(baseDefaultPrice, this.qtyMultiplier);

    this.updatePriceDisplay(
      this.getElement('[data-price-discounted]', 'picker_submit_btn-price_discounted'),
      this.getElement('[data-price-old]', 'picker_submit_btn-price_old'),
      discountedPrice,
      defaultPrice
    );
  }

  updateCheckoutButton() {
    const activeOffer = this.getActiveOffer();
    if (!activeOffer) return;

    const baseDiscountedPrice = activeOffer.getAttribute('data-discounted-price');
    const baseDefaultPrice = activeOffer.dataset.defaultPrice;

    const button = this.getElement('[data-checkout-button]', 'picker-checkout_button');
    const discountedPrice = this.scalePrice(
      this.multiplyPrice(baseDiscountedPrice, this.qtyMultiplier),
      this.extraDiscountFactor(button)
    );
    const defaultPrice = this.multiplyPrice(baseDefaultPrice, this.qtyMultiplier);

    this.updatePriceDisplay(
      this.getElement('[data-checkout-price-discounted]', 'picker_checkout_btn-price_discounted'),
      this.getElement('[data-checkout-price-old]', 'picker_checkout_btn-price_old'),
      discountedPrice,
      defaultPrice
    );
  }

  croUpdateCTA() {
    const activeOffer = this.getActiveOffer();
    if (!activeOffer) return;

    const baseOtpPrice = activeOffer.getAttribute('data-otp-discounted-price');
    const otpPrice = this.multiplyPrice(baseOtpPrice, this.qtyMultiplier);

    const otpPriceElement = this.getElement('[data-otp-price]', 'picker-otp_price');
    if (otpPriceElement) {
      otpPriceElement.textContent = otpPrice;
    }

    const otpCheckoutPriceElement = this.getElement('[data-otp-checkout-price]', 'picker-otp_price-checkout');
    if (otpCheckoutPriceElement) {
      otpCheckoutPriceElement.textContent = otpPrice;
    }
  }

  updateOfferGroups() {
    const purchaseType = this.purchaseTypeInput?.checked ? 'sub' : 'otp';

    this.offersGroups.forEach((group) => {
      // Never hide always-visible groups (dogsize_index = 0)
      if (group.hasAttribute('data-always-visible')) {
        group.style.display = 'block';
        return;
      }
      group.style.display = 'none';
    });

    const activeInput = document.querySelector('.picker-dogsize_input:checked');
    if (activeInput) {
      const activeGroupId = activeInput.getAttribute('data-offers-group') + '-' + purchaseType;
      const activeGroup = document.getElementById(activeGroupId);
      if (activeGroup) {
        activeGroup.style.display = 'block';
      }
    }

    this.updateCTA();
    this.croUpdateCTA();
    this.updateCheckoutButton();
  }

  syncOfferInputs(selectedIndex, currentGroup) {
    this.offersGroups.forEach((otherGroup) => {
      if (otherGroup !== currentGroup) {
        const correspondingRadio = otherGroup.querySelectorAll('input[type="radio"]')[selectedIndex];
        if (correspondingRadio) {
          correspondingRadio.checked = true;
        }
      }
    });
  }

  getActiveOffer() {
    for (const element of this.offersGroups) {
      if (window.getComputedStyle(element).display === 'block') {
        return element.querySelector('.picker-offer_input:checked');
      }
    }
    return null;
  }

  buildKlaviyoTags(activeOffer, isSubscription = false, actualQuantity = null) {
    const productType = activeOffer.getAttribute('data-product-type');
    const dogSizeTitle = activeOffer.getAttribute('data-dogsize');
    const sellingPlanTitle = activeOffer.getAttribute('data-interval-title');
    // Use actualQuantity (multiplied by qty selector) if provided, otherwise fallback to data-quantity
    const quantity = actualQuantity !== null ? actualQuantity : activeOffer.getAttribute('data-quantity');

    const klaviyoTagName = dogSizeTitle ? `${productType}-${dogSizeTitle}` : productType;
    let klaviyoTagValue;

    // Check if sellingPlanTitle is valid (exists and doesn't start with "0")
    const hasValidIntervalTitle = sellingPlanTitle && !sellingPlanTitle.startsWith('0');

    if (isSubscription && hasValidIntervalTitle) {
      klaviyoTagValue = sellingPlanTitle.replace(' ', '-') + '-sub';
    } else if (hasValidIntervalTitle) {
      // Has interval title but no selling plan added to cart
      klaviyoTagValue = sellingPlanTitle.replace(' ', '-') + '-nosub';
    } else {
      // No valid interval title - use quantity
      klaviyoTagValue = quantity + '-nosub';
    }

    return { [klaviyoTagName]: klaviyoTagValue };
  }

  getSourceData() {
    return {
      _source_type: document.body.dataset.sourceType,
      _source_id: document.body.dataset.sourceId,
      _source_handle: document.body.dataset.sourceHandle,
    };
  }

  getOfferTagData(activeOffer) {
    if (!activeOffer) return {};

    const offerTag = activeOffer.dataset.offerTag;
    if (!offerTag) return {};

    const result = {};
    // Parse format: "key1:value1, key2:value2, key3:value3"
    const pairs = offerTag.split(',');
    pairs.forEach((pair) => {
      const trimmedPair = pair.trim();
      const colonIndex = trimmedPair.indexOf(':');
      if (colonIndex > 0) {
        const key = trimmedPair.substring(0, colonIndex).trim();
        const value = trimmedPair.substring(colonIndex + 1).trim();
        if (key && value) {
          result[key] = value;
        }
      }
    });

    return result;
  }

  getSectionIds() {
    if (this.cart && this.cart.getSectionsToRender) {
      return this.cart.getSectionsToRender().map((section) => section.id);
    }
    return [];
  }

  /**
   * Applies the code to the session cart. Resolves once the discount is on the cart, so callers
   * can re-render off it.
   *
   * `redirect` keeps this cheap: /discount/<code> always 302s somewhere, and left to itself that
   * is the storefront home page — ~290KB of HTML fetched and thrown away on every add to cart.
   * Shopify drops any query string from the target, so it has to be a bare path; /cart.js is the
   * smallest one that still proves the cart came back.
   */
  applyDiscountCode(code) {
    if (!code) return Promise.resolve();
    const redirect = encodeURIComponent('/cart.js');
    return fetch(`/discount/${encodeURIComponent(code)}?redirect=${redirect}`, {
      method: 'GET',
    }).catch((e) => {
      console.error('Failed to apply discount code:', e);
    });
  }

  addToCartOTP() {
    const activeOffer = this.getActiveOffer();
    if (!activeOffer) {
      this.setButtonsLoading(false);
      return;
    }

    const baseQuantity = parseInt(activeOffer.getAttribute('data-quantity')) || 1;
    const quantity = baseQuantity * this.qtyMultiplier;
    const variantId = activeOffer.getAttribute('data-otp-variant-id');
    const offerTagData = this.getOfferTagData(activeOffer);

    const productData = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: {},
        },
      ],
      sections: this.skipCart ? null : this.getSectionIds(),
    };

    // OTP never adds selling_plan to cart, so isSubscription is false (based on cart line item)
    const hasSellingPlan = false;
    const klaviyoTagsArr = this.buildKlaviyoTags(activeOffer, hasSellingPlan, quantity);
    productData.items[0].properties._klaviyo_custom_tag = klaviyoTagsArr;
    productData.items[0].properties._jc_dogsize = activeOffer.getAttribute('data-dogsize');
    productData.items[0].properties._product_type = activeOffer.getAttribute('data-product-type');

    const orderAttributes = { ...klaviyoTagsArr, ...offerTagData };
    this.addToCart(productData, orderAttributes);
  }

  addToCartOTPDirectCheckout() {
    const activeOffer = this.getActiveOffer();
    if (!activeOffer) {
      this.setButtonsLoading(false);
      return;
    }

    const baseQuantity = parseInt(activeOffer.getAttribute('data-quantity')) || 1;
    const quantity = baseQuantity * this.qtyMultiplier;
    const variantId = activeOffer.getAttribute('data-otp-variant-id');
    const sourceData = this.getSourceData();
    const offerTagData = this.getOfferTagData(activeOffer);
    const sectionIds = this.getSectionIds();

    const productData = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: { ...sourceData },
        },
      ],
    };

    if (sectionIds.length > 0) {
      productData.sections = sectionIds;
    }

    // OTP never adds selling_plan to cart, so isSubscription is false (based on cart line item)
    const hasSellingPlan = false;
    const klaviyoTagsArr = this.buildKlaviyoTags(activeOffer, hasSellingPlan, quantity);
    productData.items[0].properties._klaviyo_custom_tag = klaviyoTagsArr;
    productData.items[0].properties._jc_dogsize = activeOffer.getAttribute('data-dogsize');
    productData.items[0].properties._product_type = activeOffer.getAttribute('data-product-type');

    const originalSkipCart = this.skipCart;
    this.skipCart = true;

    const orderAttributes = { ...klaviyoTagsArr, ...sourceData, ...offerTagData };

    const addToCartPromise = this.addToCart(productData, orderAttributes);

    addToCartPromise
      .catch((e) => console.error(e))
      .finally(() => {
        this.skipCart = originalSkipCart;
        this.setButtonsLoading(false);
      });
  }

  prepareAddToCart() {
    const activeOffer = this.getActiveOffer();
    if (!activeOffer) {
      this.setButtonsLoading(false);
      return;
    }

    const baseQuantity = parseInt(activeOffer.getAttribute('data-quantity')) || 1;
    const quantity = baseQuantity * this.qtyMultiplier;
    const variantId = activeOffer.getAttribute('data-variant-id');
    const sellingPlan = activeOffer.getAttribute('data-selling-plan');
    const sourceData = this.getSourceData();
    const offerTagData = this.getOfferTagData(activeOffer);

    const productData = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: { ...sourceData },
        },
      ],
      sections: this.skipCart ? null : this.getSectionIds(),
    };

    // Determine if subscription based on whether selling_plan is actually added to cart
    const hasSellingPlan = sellingPlan && sellingPlan !== 'otp';
    if (hasSellingPlan) {
      productData.items[0].selling_plan = sellingPlan;
    }

    // Build klaviyo tags based on actual cart line item (whether selling_plan exists)
    const klaviyoTagsArr = this.buildKlaviyoTags(activeOffer, hasSellingPlan, quantity);
    productData.items[0].properties._klaviyo_custom_tag = klaviyoTagsArr;
    productData.items[0].properties._jc_dogsize = activeOffer.getAttribute('data-dogsize');
    productData.items[0].properties._product_type = activeOffer.getAttribute('data-product-type');

    const originalSkipCart = this.skipCart;
    this.skipCart = false;

    const orderAttributes = { ...klaviyoTagsArr, ...sourceData, ...offerTagData };

    const executeAddToCart = (data) => {
      this.addToCart(data, orderAttributes)
        .catch((e) => console.error(e))
        .finally(() => {
          this.skipCart = originalSkipCart;
        });
    };

    executeAddToCart(productData);
  }

  addToCart(productData, orderAttributesArr = {}) {
    let sectionsToRender = [];
    if (this.cart && this.cart.getSectionsToRender) {
      sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
    }

    if (productData.sections && Array.isArray(productData.sections) && productData.sections.length > 0) {
      sectionsToRender = productData.sections;
    }

    const { sections: _, ...productDataWithoutSections } = productData;
    const requestBody = { ...productDataWithoutSections, attributes: orderAttributesArr };

    if (sectionsToRender.length > 0) {
      requestBody.sections = sectionsToRender;
    }

    return fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to add item to cart');
        }
        return response.json();
      })
      .then((response) => {
        if (response.status || response.description || response.errors) {
          console.error('Cart add error:', response);
          throw new Error(response.description || response.message || 'Error adding product to cart');
        }

        if (!response.items || response.items.length === 0) {
          console.error('Cart add failed: No items in response');
          throw new Error('Failed to add item to cart');
        }

        // Non-blocking so the drawer still opens at once, but the repaint below is rendered
        // from the add response, whose section HTML Shopify built *before* this request existed
        // — i.e. without the discount. refreshCartState re-renders from the cart once it lands,
        // which is what stops the line price and subtotal sitting there pre-discount until the
        // shopper reloads.
        if (this.discountCode) {
          this.applyDiscountCode(this.discountCode).then(() => this.refreshCartState());
        }

        // Render cart immediately without waiting for discount code
        if (!this.skipCart) {
          // Tracks whether the drawer repaint actually happened, not whether we meant to do it:
          // renderContents writes the same #CartDrawer node the cartUpdate subscriber writes, so
          // the subscriber has to skip only when this call really ran. Publishing `true` on intent
          // would leave the drawer stale whenever `sections` or `this.cart` is missing.
          let drawerRendered = false;
          if (response.sections && this.cart && this.cart.renderContents) {
            this.cart.renderContents(response);
            drawerRendered = true;
          }
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: response, drawerRendered });
        } else {
          if (response.sections && this.cart) {
            this.updateCartWithoutOpening(response);
          } else if (this.cart) {
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const cartIconBubble = html.querySelector('#cart-icon-bubble');
                if (cartIconBubble) {
                  const targetCartIcon = document.querySelector('#cart-icon-bubble');
                  if (targetCartIcon) {
                    targetCartIcon.replaceWith(cartIconBubble);
                    if (this.cart.setHeaderCartIconAccessibility) {
                      this.cart.setHeaderCartIconAccessibility();
                    }
                  }
                }
              })
              .catch((e) => {
                console.error('Error updating cart counter:', e);
              });
          }
          const checkoutUrl = this.discountCode
            ? `/checkout?discount=${encodeURIComponent(this.discountCode)}`
            : '/checkout';
          setTimeout(() => {
            window.location.href = checkoutUrl;
          }, 400);
        }
        return response;
      })
      .catch((e) => {
        console.error(e);
        alert(e.message || 'Error adding product to cart. Please try again.');
        throw e;
      })
      .finally(() => {
        this.setButtonsLoading(false);
        if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      });
  }

  prepareDirectCheckout() {
    const activeOffer = this.getActiveOffer();
    if (!activeOffer) {
      this.setButtonsLoading(false);
      return;
    }

    const baseQuantity = parseInt(activeOffer.getAttribute('data-quantity')) || 1;
    const quantity = baseQuantity * this.qtyMultiplier;
    const variantId = activeOffer.getAttribute('data-variant-id');
    const sellingPlan = activeOffer.getAttribute('data-selling-plan');
    const sourceData = this.getSourceData();
    const offerTagData = this.getOfferTagData(activeOffer);
    const sectionIds = this.getSectionIds();

    const productData = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: { ...sourceData },
        },
      ],
    };

    if (sectionIds.length > 0) {
      productData.sections = sectionIds;
    }

    // Determine if subscription based on whether selling_plan is actually added to cart
    const hasSellingPlan = sellingPlan && sellingPlan !== 'otp';
    if (hasSellingPlan) {
      productData.items[0].selling_plan = sellingPlan;
    }

    // Build klaviyo tags based on actual cart line item (whether selling_plan exists)
    const klaviyoTagsArr = this.buildKlaviyoTags(activeOffer, hasSellingPlan, quantity);
    productData.items[0].properties._klaviyo_custom_tag = klaviyoTagsArr;
    productData.items[0].properties._jc_dogsize = activeOffer.getAttribute('data-dogsize');
    productData.items[0].properties._product_type = activeOffer.getAttribute('data-product-type');

    const originalSkipCart = this.skipCart;
    this.skipCart = true;

    const orderAttributes = { ...klaviyoTagsArr, ...sourceData, ...offerTagData };

    const addToCartPromise = this.addToCart(productData, orderAttributes);

    addToCartPromise
      .catch((e) => console.error(e))
      .finally(() => {
        this.skipCart = originalSkipCart;
        this.setButtonsLoading(false);
      });
  }

  updateDogsizeSelector(dogsize) {
    const dogsizeText = dogsize.getAttribute('data-dogsize-title');
    if (this.dogSizesTrigger) {
      this.dogSizesTrigger.textContent = dogsizeText;
    }
    if (this.dogsizesTarget) {
      this.dogsizesTarget.classList.add('dogsizes-hidden');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Remove hidden-on-load classes now that JS is ready to manage visibility
  document.querySelectorAll('.picker-offer-block--hidden-on-load').forEach((el) => {
    el.classList.remove('picker-offer-block--hidden-on-load');
  });

  const newPicker = new ProductPicker();
  newPicker.updateOfferGroups();
  newPicker.updateCTA();
  newPicker.croUpdateCTA();
  newPicker.updateCheckoutButton();
});

class DeliveryTimer {
  constructor() {
    if (document.querySelector('.delivery-timer')) {
      this.initTimer();
    }
  }

  initTimer() {
    this.updateDeliveryTimer();
    setInterval(() => this.updateDeliveryTimer(), 1000);
  }

  updateDeliveryTimer() {
    const now = new Date();
    const targetTime = new Date(now);
    targetTime.setUTCHours(12, 0, 0, 0);

    const wrapper = document.querySelector('.delivery-timer');

    if (now.getUTCHours() >= 12) {
      targetTime.setUTCDate(targetTime.getUTCDate() + 1);
      wrapper.classList.remove('before_noon');
      wrapper.classList.add('after_noon');
    } else {
      wrapper.classList.remove('after_noon');
      wrapper.classList.add('before_noon');
    }

    const diff = targetTime.getTime() - now.getTime();

    const hours = this.formatTimeUnit(Math.floor(diff / (1000 * 60 * 60)));
    const minutes = this.formatTimeUnit(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
    const seconds = this.formatTimeUnit(Math.floor((diff % (1000 * 60)) / 1000));

    document.querySelector('.timer').innerHTML = `${hours} : ${minutes} : ${seconds}`;
  }

  formatTimeUnit(unit) {
    return unit < 10 ? '0' + unit : unit;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new DeliveryTimer();
});

document.addEventListener('DOMContentLoaded', function () {
  const checkbox =
    document.querySelector('[data-purchase-type-toggle]') || document.getElementById('js__picker-purchase_type');
  const wrapper = document.querySelector('.picker-purchase_type-wrapper');

  if (!checkbox || !wrapper) return;

  function toggleActiveClass() {
    if (checkbox.checked) {
      wrapper.classList.add('active');
    } else {
      wrapper.classList.remove('active');
    }
  }

  toggleActiveClass();

  checkbox.addEventListener('change', toggleActiveClass);
});

class SubscriptionNotice extends HTMLElement {
  constructor() {
    super();

    this.continueButton = this.querySelector('button');
    this.accountButton = this.querySelector('a');
    this.header = document.querySelector('header').parentElement;
    this.currentProductSku = this.dataset.sku;
    this.userCurrentSubscriptions = localStorage.getItem('user-current-subs') || [];
    this.accountLink = this.header.querySelector('.js__recharge_login_link')?.href;
    this.picker = false;
  }

  init(picker) {
    this.picker = picker;
    this.purchaseTypeInput = this.picker.purchaseTypeInput;
    this.picker ? this.continueButton.addEventListener('click', this.close.bind(this)) : null;
    this.accountLink = this.header.querySelector('.js__recharge_login_link')?.href;

    if (this.accountLink) this.accountButton.href = this.accountLink;
  }

  open() {
    let isSubscription = this.picker.purchaseTypeInput?.checked;
    if (typeof window.wuffesDosageRecForceSubscription === 'boolean') {
      isSubscription = window.wuffesDosageRecForceSubscription;
    } else if (typeof window.wuffesFeedingRecForceSubscription === 'boolean') {
      isSubscription = window.wuffesFeedingRecForceSubscription;
    }

    if (this.picker) {
      if (isSubscription && this.userCurrentSubscriptions.includes(this.currentProductSku)) {
        this.setAttribute('shown', '');
        this.header.classList.add('hidden');
        document.body.classList.add('overflow-hidden');
      } else if (typeof window.wuffesDosageRecPrepareAddToCart === 'function') {
        const fn = window.wuffesDosageRecPrepareAddToCart;
        window.wuffesDosageRecPrepareAddToCart = null;
        window.wuffesDosageRecForceSubscription = null;
        fn();
      } else if (typeof window.wuffesFeedingRecPrepareAddToCart === 'function') {
        const fn = window.wuffesFeedingRecPrepareAddToCart;
        window.wuffesFeedingRecPrepareAddToCart = null;
        window.wuffesFeedingRecForceSubscription = null;
        fn();
      } else {
        this.picker.prepareAddToCart();
      }
    }
  }

  close(event) {
    event.preventDefault();

    this.removeAttribute('shown');
    this.header.classList.remove('hidden');
    document.body.classList.remove('overflow-hidden');

    if (typeof window.wuffesDosageRecAfterSubNotice === 'function') {
      const fn = window.wuffesDosageRecAfterSubNotice;
      window.wuffesDosageRecAfterSubNotice = null;
      window.wuffesDosageRecForceSubscription = null;
      fn();
    } else if (typeof window.wuffesFeedingRecAfterSubNotice === 'function') {
      const fn = window.wuffesFeedingRecAfterSubNotice;
      window.wuffesFeedingRecAfterSubNotice = null;
      window.wuffesFeedingRecForceSubscription = null;
      fn();
    } else if (this.picker) {
      this.picker.prepareAddToCart();
    }
  }
}
customElements.define('subscription-notice', SubscriptionNotice);
